(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("index", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory(require("react"), require("react-dom"));
	else
		root["index"] = factory(root["react"], root["react-dom"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_127__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition